import Vue from 'vue';

export default Vue.extend({
  functional: true,
  template: `
        <div class="ag-custom-loading-cell" style="padding-left: 10px; line-height: 25px;">
            <i class="fa fa-spinner fa-pulse fa-fw"></i> <span>{{params.loadingMessage}}</span>
        </div>
    `
});